import React from 'react'
import {
    Flex,
    Text,
    Img,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'

//Disabled steps for not - to be revisited
//const RecipeStep = ({step, totalSteps}) => {
const RecipeStep = ({step}) => {
    const styles = useMultiStyleConfig('RecipeDetails', {})
    const {stepsMenu} = styles || {}

    return (
        <Flex {...stepsMenu?.stepContainer}>
            {step?.step_media && (
                <Flex {...stepsMenu?.stepImageContainer}>
                    <Img w="100%" src={step?.step_media?.url} />
                </Flex>
            )}
            {step.step_title && (
                //for now we disable the total -> to be revisited
                // <Text {...stepsMenu?.stepNumber}>{`${step.step_title}/${totalSteps || null}`}</Text>
                <Text {...stepsMenu?.stepNumber}>{`${step.step_title}`}</Text>
            )}
            <Flex
                flexDir="column"
                width="100%"
                dangerouslySetInnerHTML={{__html: step?.instructions}}
            ></Flex>
        </Flex>
    )
}
RecipeStep.propTypes = {
    step: PropTypes.object,
    totalSteps: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default RecipeStep
